import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { StoreDetailPageRoutingModule } from "./store-detail-routing.module";

import { StoreDetailPage } from "./store-detail.page";
import { PagesModule } from "../pages.module";
import { ShareModule } from "ngx-sharebuttons";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PagesModule,
    ShareModule,
    StoreDetailPageRoutingModule,
  ],
  declarations: [StoreDetailPage],
})
export class StoreDetailPageModule {}
